/**
 * Abstract Products View
 */
class AbstractProductsView {

	constructor(presenter, sectionId, pageSize, articleSegmentsEnabled) {

		this.parent = $("#shopify-section-" + sectionId);
		this.productsCount = $("#mon-products-count");
		this.productSorting = $("#mon-product-sorting");
		this.productFiltersOffcanvas = $("#mon-product-filters-offcanvas");
		this.productFiltersOffcanvasContainer = $("#mon-product-filters-offcanvas-container");
		this.productFiltersContainer = $("#mon-product-filters-container");
		this.productFilters = $("#mon-product-filters");
		this.productFilterActions = this.productFilters.find("a");
		this.productFiltersClear = $("a.mon-product-filters-clear");
		this.productsContainer = $("#mon-products-container");
		this.productsNone = $("#mon-products-none");
		this.productsTemplate = $("#mon-products-template");
		this.articleSegmentsEnabled = articleSegmentsEnabled;
		this.articleSegmentOne = $("#mon-article-segment-one");
		this.articleSegmentTwo = $("#mon-article-segment-two");
		this.pagination = $("#mon-pagination");
		this.paginationPrevious = $("#mon-pagination-previous");
		this.paginationPage = $("#mon-pagination-page");
		this.paginationPages = $("#mon-pagination-pages");
		this.paginationNext = $("#mon-pagination-next");
		this.localStorageAvailable = false;
		this.wishlistProductHandles = new Array();
		this.pageSize = pageSize;
		this.page = 0;
		this.pages = null;
		this.presenter = presenter;

		/*
		 * Listeners
		 */

		this.productFiltersOffcanvas.on("show.bs.offcanvas", $.proxy(function(_event) {
			// the filter offcanvas is about to be shown, so move the filters to it
			this.productFiltersOffcanvasContainer.append(this.productFilters);
		}, this));

		this.productFiltersOffcanvas.on("hidden.bs.offcanvas", $.proxy(function(_event) {
			// the filter offcanvas is hidden, so move the filters back to their default location
			this.productFiltersContainer.append(this.productFilters);
		}, this));

		this.productFilterActions.on("click", $.proxy(function(event) {
			
			// get the source of the event
			const action = $(event.currentTarget);

			// if the filter is disabled, there is nothing to do (we do not respond to the click action)
			if (action.attr("data-filter-disabled") == "true") { return; }
			
			// update the state of the action
			const icons = action.find("i.bi");
			const active = action.attr("data-filter-active");
			if (active == "inactive") {
				// we need to make the filter active
				icons.first().addClass("d-none");
				icons.last().removeClass("d-none");
				action.attr("data-filter-active", "active");
			}
			else {
				// we need to make the filter inactive
				icons.first().removeClass("d-none");
				icons.last().addClass("d-none");
				action.attr("data-filter-active", "inactive");
			}

			// we now need to build a map of all the active filters, and then pass it to the presenter
			const filterMap = new Map();
			this.productFilterActions.each(function() {
				const action = $(this);
				if (action.attr("data-filter-active") == "active") {
					const filterType = action.attr("data-filter-type");
					const filterValue = action.attr("data-filter-value");
					if (filterMap.has(filterType) == false) { filterMap.set(filterType, new Array()); }
					filterMap.get(filterType).push(filterValue);
				}
			});
			this.presenter.setFilterMap(filterMap);		// the presenter will update the pagination and set the products on the page

			// get the current filtered products, and then iterate over all the product filter actions
			const filteredProducts = this.presenter.getFilteredProducts();
			this.productFilterActions.each(function() {
				
				const productFilterAction = $(this);
				const filterType = productFilterAction.attr("data-filter-type");
				const filterValue = productFilterAction.attr("data-filter-value");
				
				// we need to check if this product filter action is present in the current list of filtered products
				var present = false;
				for (const filteredProduct of filteredProducts) {
					// check if this action is present, and if it is update the flag and break out of the loop
					const data = filteredProduct.attr("data-" + filterType);
					if (data != null && data.length > 0 && data == filterValue) {
						present = true;
						break;
					}
				}

				// check the preset flag 
				if (present == true) {
					/*
					 * This filter action is present in the current filtered set of products, 
					 * so make sure the filter action is enabled.
					 */
					productFilterAction.removeClass("link-secondary").addClass("link-dark");
					productFilterAction.find("span").last().removeClass("text-decoration-line-through");
					productFilterAction.removeAttr("data-filter-disabled");
				}
				else if (present == false && action.attr("data-filter-type") != filterType) {
					/*
					 * This filter action is not present in the current filtered set of product, 
					 * and it is not a fellow peer of the action that initiated this update, so 
					 * make sure the filter action is disabled.
					 */
					productFilterAction.removeClass("link-dark").addClass("link-secondary");
					productFilterAction.find("span").last().addClass("text-decoration-line-through");
					productFilterAction.attr("data-filter-disabled", "true");
				}

			});

		}, this));

		this.productFiltersClear.on("click", $.proxy(function(_event) {

			// iterate over all the actions to locate any that are active
			this.productFilterActions.each(function() {
				const action = $(this);
				action.removeClass("link-secondary").addClass("link-dark");
				action.find("span").last().removeClass("text-decoration-line-through");
				action.removeAttr("data-filter-disabled");
				if (action.attr("data-filter-active") == "active") {
					// we need to make the filter inactive
					const icons = action.find("i.bi");
					icons.first().removeClass("d-none");
					icons.last().addClass("d-none");
					action.attr("data-filter-active", "inactive");
				}
			});

			// pass an empty filter map to the presenter, that will also update the view
			this.presenter.setFilterMap(new Map());

		}, this));

		this.paginationPrevious.on("click", $.proxy(function(_event) {
			const page = Number(this.paginationPrevious.attr("data-page"));
			this.setProducts(page);
		}, this));

		this.paginationNext.on("click", $.proxy(function(_event) {
			const page = Number(this.paginationNext.attr("data-page"));
			this.setProducts(page);
		}, this));

		/*
		 * Initialisation
		 */

		// setup the sorting options
		const sortingTemplate = this.productSorting.find("li.d-none").first();
		for (const sort of this.getSorting()) {
			
			// setup the sorting option
			const option = sortingTemplate.clone();
			option.removeClass("d-none");
			const action = option.find("a").first();
			action.attr("data-action", sort.value);
			action.text(sort.name);
			this.productSorting.find("ul").first().append(action);
			
			// set the action for this option
			action.on("click", $.proxy(function(_event) {
				this.productSorting.find("button > span").first().text(sort.name);
				this.presenter.setSorting(sort);
			}, this));

		}

		// set the default sorting option
		this.productSorting.find("button > span").first().text(this.getSortingDefault().name);

	}

	/*
	 * Actions
	 */

	updatePagination(totalProducts) {

		// initialise the pages count
		this.pages = Math.ceil(totalProducts / this.pageSize);
		this.paginationPages.text(this.pages);
		this.pagination.removeClass("invisible");
		this.productsCount.text(totalProducts);
				
		// set the products for the first page
		if (this.pages > 0) { 
			this.setProducts(1);
			this.productsContainer.removeClass("d-none");
			this.pagination.removeClass("d-none");
			this.productsNone.addClass("d-none");
		}
		else {
			this.productsContainer.empty();
			this.productsContainer.addClass("d-none");
			this.pagination.addClass("d-none");
			this.productsNone.removeClass("d-none");
		}

	}

	updateWishlistAdd() {
		if (this.localStorageAvailable == true) {

			// local storage is available so get all the add actions and show them
			const wishlistAddAction = this.productsContainer.find("a.mon-wishlist-add");
			wishlistAddAction.removeClass("d-none");

			// had a handler to add the product to the wishlist
			wishlistAddAction.on("click", $.proxy(function(event) {
				// get the product handle, and then request it is added to the wishlist
				const handle = $(event.currentTarget).attr("data-product-handle");
				this.presenter.wishlistAdd(handle);
			}, this));

			// iterate over the add actions to see if their handle is in the list of wishlist products
			wishlistAddAction.each($.proxy(function(_index, element) {
				// get the handle and see if it is in the list of wishlist product handles
				const action = $(element);
				const handle = action.attr("data-product-handle");
				if (this.wishlistProductHandles.includes(handle)) {
					// we make the filled icon always visible by removing its transition class
					action.find("i.mon-icon-transition-top").removeClass("mon-icon-transition-top");
				}
			}, this));

		}
	}

	updateFilters(product) {
		
		// build out the update function for the filters in the user interface
		const update = $.proxy(function(attribute) {
			const value = product.attr(attribute);
			if (value != null && value.length > 0) {
				// this filter value is present in the product, so make the filter value visible in the user inter
				const filter = this.productFilters.find("div[" + attribute + "=\"" + value + "\"]");
				if (filter != null && filter.length > 0) {
					filter.removeClass("d-none");
					filter.closest(".accordion-item").removeClass("d-none");
				}
			}
		}, this);

		// iterate over the filters and call the update function
		for (const attribute of this.getFilters()) { update(attribute); }
		
	}

	/*
	 * Getters and Setters
	 */

	setProducts(page) {
		
		// get the products for this page
		const products = this.presenter.getProducts(page, this.pageSize);
		this.page = page;

		// add the products to the view
		this.productsContainer.empty();
		var index = 1;
		for (const product of products) {

			// check to see if one of the article segments needs to be added
			if (this.articleSegmentsEnabled == true && index == 7) {
				const template = this.articleSegmentOne.clone();
				template.removeAttr("id");
				template.removeClass("d-none");
				this.productsContainer.append(template);
				index = index + 2;
			}
			else if (this.articleSegmentsEnabled == true && index == 17) {
				const template = this.articleSegmentTwo.clone();
				template.removeAttr("id");
				template.removeClass("d-none");
				this.productsContainer.append(template);
				index = index + 2;
			}
			
			// add the product
			const template = this.productsTemplate.clone();
			template.removeAttr("id");
			template.removeClass("d-none");
			template.append(product);
			this.productsContainer.append(template);
			index++;

		}

		// if required update the wishlist add function
		this.updateWishlistAdd();

		// update the pagination
		if (page > 1) {
			this.paginationPrevious.removeClass("invisible");
			this.paginationPrevious.attr("data-page", (page - 1));
		}
		else {
			this.paginationPrevious.addClass("invisible");
			this.paginationPrevious.removeAttr("data-page");
		}
		if (page < this.pages) {
			this.paginationNext.removeClass("invisible");
			this.paginationNext.attr("data-page", (page + 1));
		}
		else {
			this.paginationNext.addClass("invisible");
			this.paginationNext.removeAttr("data-page");
		}
		this.paginationPage.text(page);

	}

	// TODO
	setDataLoaded() {}

	getSorting() {
		return [
			{ value: "title-ascending", name: "Name Ascending", type: "title", direction: 1 },
			{ value: "title-descending", name: "Name Descending", type: "title", direction: -1 },
			{ value: "price-ascending", name: "Price Ascending", type: "price", direction: 1 },
			{ value: "price-descending", name: "Price Descending", type: "price", direction: -1 },
			{ value: "created-ascending", name: "Created Ascending", type: "created", direction: 1 },
			{ value: "created-descending", name: "Created Descending", type: "created", direction: -1 }
	  ];
	}

	getSortingDefault() {
		return this.getSorting()[0];
	}

	getFilters() {
		return [
			"data-available-now",
			"data-filter-price",
			"data-product-vendor",
			"data-brand-collection",
			"data-filter-case-material",
			"data-filter-case-size",
			"data-filter-dial-colour",
			"data-filter-bracelet-strap",
			"data-filter-movement",
			"data-filter-water-resistance",
			"data-filter-jewellery-products",
			"data-filter-jewellery-material",
			"data-filter-accessory-type",
			"data-filter-gender"
		];
	}

	setLocalStorageAvailable() {
		// set the availability flag and update any loaded products
		this.localStorageAvailable = true;
		this.updateWishlistAdd();
	}

	setWishlistProductHandles(wishlistProductHandles) {
		// set the list of wishlist product handles
		this.wishlistProductHandles = wishlistProductHandles;
	}

}